import { memo } from 'react';

import { PermissionToggleInfo } from '~/components/SharePrivateContentModal/shared/PermissionToggleInfo';
import { SharePrivateContentPermissionToggle } from '~/components/SharePrivateContentModal/shared/SharePrivateContentPermissionToggle';

type EnableShareLinkDownloadToggleProps = {
  checked: boolean;
  isLoading: boolean;
  onToggle: (enabled: boolean) => void;
  infoText: string;
  disabled?: boolean;
};

export const EnableShareLinkDownloadToggle = memo(
  ({ onToggle, checked, isLoading, infoText, disabled }: EnableShareLinkDownloadToggleProps) => {
    return (
      <SharePrivateContentPermissionToggle
        id="canViewOriginal"
        label="Allow downloads"
        checked={checked}
        isLoading={isLoading}
        onCheckedChange={onToggle}
        disabled={disabled}
      >
        <PermissionToggleInfo text={infoText} />
      </SharePrivateContentPermissionToggle>
    );
  },
);

EnableShareLinkDownloadToggle.displayName = 'EnableShareLinkDownloadToggle';
